import { handleResponse, buildUrl } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const checkAvailability = (payload) =>
  fetch(buildUrl("/api/bookings/availability"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const createBooking = (payload) =>
  fetch(buildUrl("/api/bookings"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const createGuestBooking = (payload) =>
  fetch(buildUrl("/api/bookings/guest"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const createEventBooking = (payload) =>
  fetch(buildUrl("/api/bookings/events"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const createGuestEventBooking = (payload) =>
  fetch(buildUrl("/api/bookings/events/guest"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const getBookings = () =>
  fetch(buildUrl("/api/bookings"), {
    credentials: "include",
  }).then(handleResponse);

export const rescheduleBooking = (bookingId, payload) =>
  fetch(buildUrl(`/api/bookings/${bookingId}/reschedule`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const cancelBooking = (bookingId, payload) =>
  fetch(buildUrl(`/api/bookings/${bookingId}/cancel`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

const bookingsApi = {
  checkAvailability,
  createBooking,
  createGuestBooking,
  createEventBooking,
  createGuestEventBooking,
  getBookings,
  rescheduleBooking,
  cancelBooking,
};

export default bookingsApi;
